<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>司机授信列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 卡片 -->
        <el-card class="box-card" style="margin-top:20px">
            <!-- 搜索  新增-->
            <el-form
                    :inline="true"
                    :model="searchForm"
                    :rules="searchRules"
                    ref="searchForRef"
                    label-width="80px"
                    autocomplete="on"
                    size="mini"
            >
                <el-row :gutter="24">
                    <el-col :span="24">

                        <el-form-item label="司机">
                            <el-input v-model="searchForm.title" clearable type="text"></el-input>
                        </el-form-item>
                        <el-form-item label="车辆">
                            <el-cascader v-model="searchForm.style_ids"
                                         style="width: 100%" ref="cascaderCarStyle" @change="getval($event)"
                                         :props="{ value: 'id',label: 'name',children: 'children',checkStrictly: true}" :options="carStyleMenus" clearable></el-cascader>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select
                                    v-model="searchForm.year_id"
                                    filterable
                                    clearable
                                    default-first-option
                                    placeholder="请选择状态">
                                <el-option
                                        v-for="item in carYearList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="success"  @click="searchSubmit()">搜索</el-button>
                            <el-button type="primary" @click="goAdd()">
                                <i class="el-icon-plus" ></i>新增
                            </el-button>
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div v-if="sma" style="column-gap: 20px; display: flex;flex-direction: row;justify-content: flex-start;align-items: center;">
                            <p>
                                <label style="color: #999;">授信总额：</label><span>{{formatNumber(sma.auth_total_amount)}}</span>
                            </p>
                            <p>
                                <label  style="color: #999;">已使用授信总额：</label><span>{{formatNumber(sma.auth_total_used_amount)}}</span>
                            </p>
                            <p>
                                <label  style="color: #999;">可授信总额：</label><span>{{formatNumber(sma.recharge_total_amount)-formatNumber(sma.auth_total_amount)}}</span>
                            </p>
                            <p>
                                <label  style="color: #999;">转账总额：</label><span>{{formatNumber(sma.recharge_total_amount)}}</span>
                            </p>
                        </div>
                    </el-col>
                </el-row>
            </el-form>

            <!-- 表格 -->
            <el-table
                    ref="multipleTable"
                    :data="tableLoadData"
                    height="450"
                    stripe
                    border
                    size="mini"
            >
                <el-table-column
                        type="selection"
                        width="55">
                </el-table-column>
                <el-table-column :index="indexMethod" type="index" label="序号" width="50"></el-table-column>

                <el-table-column
                        label="司机姓名"
                        width="100"
                        :show-overflow-tooltip='true'
                >
                    <template slot-scope="scope">
                        {{scope.row.owner.name}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="手机号"
                        width="100"
                        :show-overflow-tooltip='true'
                >
                    <template slot-scope="scope">
                        {{scope.row.owner.tel}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="车牌号"
                        width="100"
                        :show-overflow-tooltip='true'
                >
                    <template slot-scope="scope">
                        {{scope.row.carinfo.car_number}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="物流公司"
                        width="120"
                        :show-overflow-tooltip='true'
                >
                    <template slot-scope="scope">
                        {{scope.row.lgsshop.name}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="授信金额"
                        width="80"
                        :show-overflow-tooltip='true'
                >
                    <template slot-scope="scope">
                        {{scope.row.auth_amount}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="已使用授信金额"
                        width="120"
                >
                    <template slot-scope="scope">
                        {{scope.row.auth_used_amount}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="未使用授信金额"
                        width="120"
                >
                    <template slot-scope="scope">
                        {{scope.row.auth_amount - scope.row.auth_used_amount}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="状态"
                >
                    <template slot-scope="scope">
                        <span style="color: #5daf34">{{scope.row.status==1?'正常':''}}</span>
                        <span>{{scope.row.status==0?'':''}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="开始日期"
                        width="150"
                >
                    <template slot-scope="scope">
                        {{scope.row.start_time|timeFormat}}
                    </template>
                </el-table-column>
                <el-table-column
                        width="150"
                        label="添加日期"
                >
                    <template slot-scope="scope">
                        {{scope.row.add_time|timeFormat}}
                    </template>
                </el-table-column>

                <el-table-column
                        fixed="right"
                        label="操作"
                        width="160">
                    <template slot-scope="scope">
                        <el-button @click="goStop(scope.row)"  type="text" size="mini">禁用</el-button>
                        <el-button style="color:#ff0000" @click="goEdit(scope.row)"  type="text" size="mini">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="block" style="margin-top:10px">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageNum"
                        :page-sizes="[10, 20, 30, 100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>
        </el-card>
        <!-- 新增编辑弹框 -->

        <el-drawer
                title="编辑授信金额"
                size="50%"
                :visible.sync="drawerShow"
                :with-header="false">

            <el-form
                    :inline="false"
                    :model="form"
                    :rules="rules"
                    ref="formForRef"
                    label-width="200px"
                    autocomplete="on"
                    size="mini"
            >
                <div style="margin: 20px;">
                    <div class="container">
                        <!-- 当前额度信息 -->
                        <div >
                            <div slot="header">
                                <span>当前额度信息</span>
                            </div>
                            <div>
                                <el-row :gutter="20">
                                    <el-col :span="8">
                                        <div style="text-align: center;">
                                            <div style="font-size: 14px; color: #909399;">总授信额度</div>
                                            <div style="font-size: 24px; font-weight: bold; color: #303133; margin-top: 5px;">
                                                ¥ {{ formatAmount(currentCredit.total) }}
                                            </div>
                                        </div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div style="text-align: center;">
                                            <div style="font-size: 14px; color: #909399;">已用额度</div>
                                            <div style="font-size: 24px; font-weight: bold; color: #e6a23c; margin-top: 5px;">
                                                ¥ {{ formatAmount(currentCredit.used) }}
                                            </div>
                                        </div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div style="text-align: center;">
                                            <div style="font-size: 14px; color: #909399;">可用额度</div>
                                            <div style="font-size: 24px; font-weight: bold; color: #67c23a; margin-top: 5px;">
                                                ¥ {{ formatAmount(currentCredit.available) }}
                                            </div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>

                        <!-- 额度调整表单 -->
                        <div shadow="never" style="margin-top: 20px;">
                            <div slot="header">
                                <span>额度调整</span>
                            </div>

                            <el-form :model="form" :rules="rules" ref="creditForm" size="mini" label-width="120px">
                                <!-- 操作类型选择 -->
                                <div class="operation-type">
                                    <h3>操作类型</h3>
                                    <el-radio-group v-model="form.operationType" @change="handleOperationTypeChange">
                                        <el-radio label="increase">增加授信额度</el-radio>
                                        <el-radio label="decrease">减少授信额度</el-radio>
                                    </el-radio-group>
                                </div>

                                <!-- 增加额度输入框 -->
                                <el-form-item
                                        label="增加授信额度"
                                        prop="auth_amount_inc"
                                        :class="{'amount-input': true, 'disabled': form.operationType !== 'increase'}"
                                        v-show="form.operationType === 'increase'">
                                    <el-input
                                            placeholder="请输入增加授信额度"
                                            type="number"
                                            v-model="form.auth_amount_inc"
                                            :disabled="form.operationType !== 'increase'"
                                            @input="validateIncreaseAmount">
                                        <template slot="append">元</template>
                                    </el-input>
                                    <div style="font-size: 12px; color: #909399; margin-top: 5px;">
                                        调整后总额度: ¥ {{ formatAmount(calculateNewTotal()) }}
                                    </div>
                                    <div style="font-size: 12px; color: #909399; margin-top: 5px;">
                                        最大可增加额度: ¥ {{ formatAmount(maxIncreaseAmount) }}
                                    </div>
                                    <div v-if="form.auth_amount_inc > maxIncreaseAmount" style="font-size: 12px; color: #f56c6c; margin-top: 5px;">
                                        警告：增加额度超过最大可增加额度！
                                    </div>
                                </el-form-item>

                                <!-- 减少额度输入框 -->
                                <el-form-item
                                        label="减少授信额度"
                                        prop="auth_amount_dec"
                                        :class="{'amount-input': true, 'disabled': form.operationType !== 'decrease'}"
                                        v-show="form.operationType === 'decrease'">
                                    <el-input
                                            placeholder="请输入减少授信额度"
                                            type="number"
                                            v-model="form.auth_amount_dec"
                                            :disabled="form.operationType !== 'decrease'"
                                            @input="validateDecreaseAmount">
                                        <template slot="append">元</template>
                                    </el-input>
                                    <div style="font-size: 12px; color: #909399; margin-top: 5px;">
                                        调整后总额度: ¥ {{ formatAmount(calculateNewTotal()) }}
                                    </div>
                                    <div style="font-size: 12px; color: #909399; margin-top: 5px;">
                                        最大可减少额度: ¥ {{ formatAmount(maxDecreaseAmount) }}
                                    </div>
                                    <div v-if="form.auth_amount_dec > maxDecreaseAmount" style="font-size: 12px; color: #f56c6c; margin-top: 5px;">
                                        警告：减少额度超过最大可减少额度！
                                    </div>
                                </el-form-item>

                                <!-- 备注 -->
                                <el-form-item label="调整原因" prop="reason">
                                    <el-input
                                            type="textarea"
                                            :rows="3"
                                            placeholder="请输入额度调整原因"
                                            v-model="form.reason">
                                    </el-input>
                                </el-form-item>

                                <!-- 操作按钮 -->
                                <div class="form-actions">
                                    <el-button size="mini"  @click="resetForm">取消</el-button>
                                    <el-button
                                            size="mini"
                                            type="primary"
                                            :disabled="is_disabled || !isFormValid"
                                            @click="submitForm('creditForm')"
                                            :loading="loading">
                                        {{ loading ? '提交中...' : '保存' }}
                                    </el-button>
                                </div>
                            </el-form>
                        </div>

                        <!-- 提交结果 -->
                        <div class="result-area" v-if="submitResult">
                            <h3>操作结果</h3>
                            <p>{{ submitResult }}</p>
                        </div>
                    </div>
                </div>
            </el-form>

        </el-drawer>
    </div>
</template>

<script>
    import moment from 'moment'     //日期时间转换

    export default {
        name: "carinfoOwnerLgsList",
        components: {

        },
        props: {},
        data() {
            // 验证增加额度的函数
            const validateIncrease = (rule, value, callback) => {
                if (this.form.operationType === 'increase') {
                    if (!value || value <= 0) {
                        callback(new Error('请输入有效的增加额度'));
                    } else if (parseFloat(value) > this.maxIncreaseAmount) {
                        callback(new Error(`增加额度不能超过最大可增加额度 ${this.formatAmount(this.maxIncreaseAmount)}`));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            };

            // 验证减少额度的函数
            const validateDecrease = (rule, value, callback) => {
                if (this.form.operationType === 'decrease') {
                    if (!value || value <= 0) {
                        callback(new Error('请输入有效的减少额度'));
                    } else if (parseFloat(value) > this.maxDecreaseAmount) {
                        callback(new Error(`减少额度不能超过最大可减少额度 ${this.formatAmount(this.maxDecreaseAmount)}`));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            };

            return {

                sma:null,
                carStyleMenus:[],
                pitch_id:'',
                drawerShow:false,
                hubList:[],
                total1:0,
                pageNum1:1,
                pageSize1:20,

                formData:{},
                title:'',
                visible:false,
                // 搜索
                searchForm: {
                    title: "",
                    style_ids:[],
                    style_id:'',
                    year_id:''
                },
                carYearList:[],
                searchRules: {

                    name: [
                        { required: true, message: "请输入名称", trigger: "blur" }
                    ],
                },
                // 数据
                tableLoadData: [],
                pageNum:1,// 当前页码
                pageSize:10,// 每页大小
                total:0,//总条目数

                showType: '',

                roleList: [],

                rules: {
                    auth_amount_inc: [
                        { validator: validateIncrease, trigger: 'blur' }
                    ],
                    auth_amount_dec: [
                        { validator: validateDecrease, trigger: 'blur' }
                    ],
                    reason: [
                        { required: true, message: '请输入调整原因', trigger: 'blur' }
                    ]

                },
                dialogFormVisible: false,
                is_disabled:false,
                form: {
                    name: '',
                    operationType: 'increase', // 默认选择增加额度
                    auth_amount_inc: '',
                    auth_amount_dec: '',
                    reason: '',
                    id:'',
                    item:null
                },
                loading: false,
                submitResult: '',
                currentCredit: {
                    total: 0, // 总授信额度
                    used: 0,  // 已用额度
                    available: 0 // 可用额度
                },
                // 最大可增加额度（小于等于可用额度）
                maxIncreaseAmount: 0,
                // 最大可减少额度（小于总授信额度-已使用额度）
                maxDecreaseAmount: 0,
                history: [
                    {
                        id: 1,
                        date: '2023-05-15 14:30',
                        type: 'increase',
                        amount: 10000,
                        reason: '客户信用良好，提升额度'
                    },
                    {
                        id: 2,
                        date: '2023-04-20 10:15',
                        type: 'decrease',
                        amount: 5000,
                        reason: '客户申请降低额度'
                    },
                    {
                        id: 3,
                        date: '2023-03-10 16:45',
                        type: 'increase',
                        amount: 20000,
                        reason: '季度额度调整'
                    }
                ]
            };
        },
        computed: {
            // 计算新的总额度
            calculateNewTotal() {
                return () => {
                    let newTotal = this.currentCredit.total;
                    if (this.form.operationType === 'increase' && this.form.auth_amount_inc) {
                        newTotal += parseFloat(this.form.auth_amount_inc);
                    } else if (this.form.operationType === 'decrease' && this.form.auth_amount_dec) {
                        newTotal -= parseFloat(this.form.auth_amount_dec);
                    }
                    return newTotal;
                };
            },
            // 表单是否有效
            isFormValid() {
                if (this.form.operationType === 'increase') {
                    return this.form.auth_amount_inc &&
                        parseFloat(this.form.auth_amount_inc) > 0 &&
                        parseFloat(this.form.auth_amount_inc) <= this.maxIncreaseAmount &&
                        this.form.reason;
                } else if (this.form.operationType === 'decrease') {
                    return this.form.auth_amount_dec &&
                        parseFloat(this.form.auth_amount_dec) > 0 &&
                        parseFloat(this.form.auth_amount_dec) <= this.maxDecreaseAmount &&
                        this.form.reason;
                }
                return false;
            }
        },
        created() {
            this.DataList();
            this.getShopMoneyAmountOne();
            this.getCarStyleMenus();
            this.getCarYeaList();
        },
        mounted() {
        },
        filters: {
            //时间格式化
            dateFormat(add_time) {
                if (add_time == undefined) {
                    return "";
                }
                return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
            },
            timeFormat(add_time) {
                if (add_time == undefined) {
                    return "";
                }
                return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
            },

        },
        methods: {
            // 验证增加金额
            validateIncreaseAmount() {
                if (this.form.auth_amount_inc && parseFloat(this.form.auth_amount_inc) > this.maxIncreaseAmount) {
                    this.$message.warning(`增加额度不能超过最大可增加额度 ${this.formatAmount(this.maxIncreaseAmount)}`);
                }
            },

            // 验证减少金额
            validateDecreaseAmount() {
                if (this.form.auth_amount_dec && parseFloat(this.form.auth_amount_dec) > this.maxDecreaseAmount) {
                    this.$message.warning(`减少额度不能超过最大可减少额度 ${this.formatAmount(this.maxDecreaseAmount)}`);
                }
            },

            formatNumber(num) {
                return new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(num);
            },
            getCarStyleMenus(){
                let _this = this;
                let params={
                    access_token:sessionStorage.getItem('token'),
                    company_id:sessionStorage.getItem('company_id'),
                };
                this.$axios.findCarStyleTree(params).then((res)=>{
                    if(res.code == 200) {
                        _this.carStyleMenus=res.data;
                    }
                });
            },
            getShopMoneyAmountOne(){
                let _this = this;
                let params={
                    access_token:sessionStorage.getItem('token'),
                    company_id:sessionStorage.getItem('company_id'),
                    shop_id:sessionStorage.getItem('shop_id'),
                };
                this.$axios.findShopMoneyAmountOne(params).then((res)=>{
                    if(res.code == 200) {
                        _this.sma=res.data;
                    }
                });
            },

            getCarYeaList(){
                let _this = this;
                let params={
                    access_token:sessionStorage.getItem('token'),
                    company_id:sessionStorage.getItem('company_id'),
                };
                this.$axios. findCarYearList(params).then((res)=>{
                    if(res.code == 200) {
                        _this.carYearList=res.data;
                    }
                });
            },
            getval() {
                let _this = this;
                const obj = this.$refs['cascaderCarStyle'].getCheckedNodes();
                console.log('obj',obj)
                if(obj.length>0){
                    _this.searchForm.style_id = obj[0].data.id;
                }else{
                    _this.searchForm.style_id="";
                }

            },
            relationHub(row){
                this.drawerHub=true;
                this.pitch_id=row.pitch_id;
                this.getHubList();
            },
            getHubList(){
                const param = {
                    company_id:sessionStorage.getItem('company_id'),
                    access_token:sessionStorage.getItem('token'),
                    pageNum1:this.pageNum1,
                    pageSize1: this.pageSize1,
                    pitch_id:this.pitch_id
                }
                this.$axios.findHubListP(param).then(res=>{
                    if(res.code == 200){
                        //  console.log(res,1111);
                        this.hubList = res.data.data
                        this.total1 = res.data.total
                    }
                }).catch(error=>{
                    console.log(error);
                })
            },
            closeForm(){
                this.title="";
                this.visible=false;
            },
            goEdit(row){
                this.form.id=row.id;
                this.form.item=row;

                // 计算当前额度信息
                const driverAvailable = parseFloat(row.auth_amount) - parseFloat(row.auth_used_amount);
                const globalAvailable = parseFloat(this.sma.recharge_total_amount) - parseFloat(this.sma.auth_total_amount);

                this.currentCredit = {
                    total: parseFloat(row.auth_amount),
                    used: parseFloat(row.auth_used_amount),
                    available: driverAvailable
                };

                // 设置最大可增加额度（小于等于可用额度）
                this.maxIncreaseAmount = globalAvailable;

                // 设置最大可减少额度（小于总授信额度-已使用额度）
                this.maxDecreaseAmount = driverAvailable;

                this.drawerShow=true;
            },
            // 处理操作类型变化
            handleOperationTypeChange(value) {
                // 切换操作类型时清空另一个输入框
                if (value === 'increase') {
                    this.form.auth_amount_dec = '';
                } else {
                    this.form.auth_amount_inc = '';
                }
                this.submitResult = '';

                // 清除验证状态
                if (this.$refs.creditForm) {
                    this.$refs.creditForm.clearValidate();
                }
            },

            // 提交表单
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        this.is_disabled = true;

                        // 准备提交数据
                        const submitData = {
                            id: this.form.id,
                            reason: this.form.reason,
                            access_token: sessionStorage.getItem('token'),
                            company_id: sessionStorage.getItem('company_id')
                        };

                        if (this.form.operationType === 'increase') {
                            submitData.auth_amount_inc = parseFloat(this.form.auth_amount_inc);
                        } else {
                            submitData.auth_amount_dec = parseFloat(this.form.auth_amount_dec);
                        }

                        // 调用API
                        this.$axios.CarInfoLgsOwnerChange(submitData).then(res => {
                            if (res.code == 200) {
                                this.$message.success('额度调整成功');
                                this.submitResult = `额度${this.form.operationType === 'increase' ? '增加' : '减少'}成功！调整金额: ¥${this.formatAmount(this.form.operationType === 'increase' ? this.form.auth_amount_inc : this.form.auth_amount_dec)}`;

                                // 刷新数据
                                this.DataList();
                                this.getShopMoneyAmountOne();

                                // 延迟关闭弹窗
                                setTimeout(() => {
                                    this.drawerShow = false;
                                    this.resetForm();
                                }, 1500);
                            } else {
                                this.$message.error(res.msg || '操作失败');
                            }
                        }).catch(error => {
                            console.error(error);
                            this.$message.error('网络错误，请重试');
                        }).finally(() => {
                            this.loading = false;
                            this.is_disabled = false;
                        });

                    } else {
                        this.$message.error('请检查表单填写是否正确');
                        return false;
                    }
                });
            },

            // 重置表单
            resetForm() {
                this.form = {
                    operationType: 'increase',
                    auth_amount_inc: '',
                    auth_amount_dec: '',
                    reason: '',
                    id: '',
                    item: null
                };
                this.submitResult = '';
                this.maxIncreaseAmount = 0;
                this.maxDecreaseAmount = 0;

                // 清除验证状态
                if (this.$refs.creditForm) {
                    this.$refs.creditForm.clearValidate();
                }
            },

            // 格式化金额显示
            formatAmount(amount) {
                if (!amount && amount !== 0) return '0.00';
                return parseFloat(amount).toLocaleString('zh-CN', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
            },
            goAdd(){
                this.$router.push('/carinfoOwnerLgsForm')
            },
            indexMethod(index) {
                return (this.pageNum - 1) * this.pageSize + index + 1
            },
            DataList(){
                const param = {
                    access_token:sessionStorage.getItem('token'),
                    company_id:sessionStorage.getItem('company_id'),
                    lgs_shop_id:sessionStorage.getItem('shop_id'),
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                }

                if(this.searchForm.title){
                    param.keyword=this.searchForm.title;
                }
                console.log(this.searchForm.style_ids)
                if(this.searchForm.style_id){
                    param.style_id=this.searchForm.style_id;
                }
                if(this.searchForm.year_id){
                    param.year_id=this.searchForm.year_id;
                }
                this.$axios.carinfoOwnerLgsListP(param).then(res=>{
                    if(res.code == 200){
                        this.tableLoadData = res.data.data
                        this.total = res.data.total
                    }
                }).catch(error=>{
                    console.log(error);
                })
            },
            // 设置每页条数
            handleSizeChange(newSize) {
                this.pageSize = newSize
                this.DataList()
            },
            // 分页跳转
            handleCurrentChange(newPage) {
                this.pageNum = newPage
                this.DataList()
            },
            handleSizeChange1(newSize) {
                this.pageSize1 = newSize
                this.getHubList()
            },
            // 分页跳转
            handleCurrentChange1(newPage) {
                this.pageNum1 = newPage
                this.getHubList()
            },
            departData(){
                const param = {
                    company_id:sessionStorage.getItem('company_id'),
                    access_token:sessionStorage.getItem('token'),
                }
                this.$axios.findTree(param).then(res=>{
                    if(res.code == 200){
                        this.rightslist = res.data.data
                    }
                }).catch(error=>{
                    console.log(error);
                })
            },

            // 新增
            addData() {
                this.$router.push('/newsForm')
            },
            handelEdit(index) {
                this.id = index.data.row.id
                this.title = '编辑'
                this.form = {
                    name: this.name,
                }
                this.dialogFormVisible = true
                this.form = JSON.parse(JSON.stringify(index.data.row))
            },

            reset_dialogForm(formName) {
                this.dialogFormVisible = false
                this.$nextTick(() => {
                    this.$refs[formName].resetFields()
                })
            },

            searchSubmit() {
                this.total=0;
                this.pageNum=1;
                this.tableLoadData=[];

                this.DataList();
            },

            handelDel(e) {
                console.log(e);
                this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const param = {
                        operator_id: sessionStorage.getItem('user_id'),
                        company_id:sessionStorage.getItem('company_id'),
                        access_token:sessionStorage.getItem('token'),
                        id: e.data.row.id,
                    }
                    this.$axios.insuranceCorpDel(param).then(res=>{
                        if(res.code == 200){
                            this.$message.success(res.msg);
                            this.DataList()
                        }else{
                            this.$message.error(res.msg);
                        }
                    }).catch(error=>{
                        console.log(error);
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                    this.DataList()
                });
                this.teamDialog = false
            },


        },
    };
</script>
<style>
    .container {
        max-width: 800px;
        margin: 0 auto;
        background: white;
        border-radius: 8px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        padding: 30px;
    }

    .header {
        text-align: center;
        margin-bottom: 30px;
        padding-bottom: 20px;
        border-bottom: 1px solid #e4e7ed;
    }

    .header h1 {
        color: #303133;
        font-size: 24px;
        margin-bottom: 10px;
    }

    .header p {
        color: #909399;
        font-size: 14px;
    }

    .form-section {
        margin-bottom: 30px;
    }

    .operation-type {
        margin-bottom: 20px;
        padding: 15px;
        background: #f8f9fa;
        border-radius: 6px;
    }

    .operation-type h3 {
        margin-bottom: 15px;
        color: #303133;
    }

    .amount-input {
        transition: all 0.3s;
    }

    .amount-input.disabled {
        opacity: 0.6;
    }

    .form-actions {
        text-align: center;
        margin-top: 30px;
        padding-top: 20px;
        border-top: 1px solid #e4e7ed;
    }

    .result-area {
        margin-top: 20px;
        padding: 15px;
        background: #f0f9ff;
        border-radius: 4px;
        border-left: 4px solid #67c23a;
    }

    .history-section {
        margin-top: 40px;
    }

    .history-section h2 {
        color: #303133;
        margin-bottom: 15px;
        font-size: 18px;
    }

    .history-item {
        display: flex;
        justify-content: space-between;
        padding: 10px 15px;
        border-bottom: 1px solid #e4e7ed;
    }

    .history-item:last-child {
        border-bottom: none;
    }

    .amount-increase {
        color: #67c23a;
    }

    .amount-decrease {
        color: #f56c6c;
    }

    @media (max-width: 768px) {
        .container {
            padding: 20px;
        }
    }
</style>
